var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"correct",attrs:{"src":require("@/assets/spot-the-not/Correct.png"),"srcset":require("@/assets/spot-the-not/Correct.png") + ' 1x, ' + require("../assets/spot-the-not/Correct@2x.png") + ' 2x',"alt":"","rel":"preload"}})}
var staticRenderFns = []

export { render, staticRenderFns }